export default __webpack_public_path__ + "static/media/arco-ajuda.acb7c654.webp";